import API from './axios';
import { AuthResponse, LoginPayload, RegisterPayload, OtpPayload } from '../types';

export const loginApi = async (payload: LoginPayload): Promise<AuthResponse> => {
  const response = await API.post('/auth/login', payload);
  return response.data;
};

export const registerApi = async (payload: RegisterPayload): Promise<any> => {
  const response = await API.post('/auth/register', payload);
  return response.data;
};

export const sendOtpApi = async (phone?: string, email?: string): Promise<any> => {
  const response = await API.post('/auth/send_otp', { phone, email });
  return response.data;
};

export const verifyOtpApi = async (payload: OtpPayload): Promise<AuthResponse> => {
  const response = await API.post('/auth/verify_otp', payload);
  return response.data;
};

export const refreshTokenApi = async (refresh_token: string): Promise<any> => {
  const response = await API.post('/auth/refresh', { refresh_token });
  return response.data;
};